import { TextButton } from '@creditornot/cb-button';
import { typographyCss, cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import styled from 'styled-components';

import { usePluralization } from 'common/hooks';
import { VenueWithSharedMenuLinkInfo } from 'modules/shared-menu/hooks/useVenuesWithSelectionLinks';

type VenueListFooterProps = {
  onSelectAll: () => void;
  onDeselectAll: () => void;
  selectedShownVenues: VenueWithSharedMenuLinkInfo[];
  shownVenues: VenueWithSharedMenuLinkInfo[];
};

const SelectionContainer = styled.div`
  display: flex;
  width: 100%;
  flex-grow: 1;
  padding-inline-end: 16px;
  gap: 16px;
`;

const VenueCount = styled.span`
  ${typographyCss.Body3}
  color: ${cbSemanticCssVars.textSecondary};
`;

export const VenueListFooter = ({
  onSelectAll,
  onDeselectAll,
  selectedShownVenues,
  shownVenues,
}: VenueListFooterProps) => {
  const { FormattedPluralMessage } = usePluralization();

  return (
    <SelectionContainer>
      <VenueCount>
        <FormattedPluralMessage id="shared-menu.toolbar.venues-total" count={shownVenues.length} />
      </VenueCount>
      {shownVenues.length > 0 && (
        <TextButton size="small" onClick={onSelectAll} variant="blue">
          <FormattedPluralMessage id="shared-menu.link.shared-menu-selected.select-venues" count={shownVenues.length} />
        </TextButton>
      )}
      {selectedShownVenues.length > 0 && (
        <TextButton size="small" onClick={onDeselectAll} variant="red">
          <FormattedPluralMessage
            id="shared-menu.link.shared-menu-selected.deselect-venues"
            count={selectedShownVenues.length}
          />
        </TextButton>
      )}
    </SelectionContainer>
  );
};
